import SecureCodingImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/secure_coding.svg";
import SecureConceptsImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/security_concepts.svg";
import SecureDevelopmentImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/secure_development.svg";
import AiLlmImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/ai_llm.svg";
import AiFoundationsImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/ai_foundations.svg";
import AiSkillsWorkflowsImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/ai_skills_workflows.svg";
import AiAgentsImageUrl from "sj-ui-toolkit/src/atlas/assets/images/knowledge_assessments/ai_agents.svg";
import { KA_CATEGORIES } from "sj-ui-toolkit/src/atlas/utils/kaConstants";

export const SELF_SELECT = "selfSelect";
export const ASSIGN_SPECIFIC = "assignSpecific";
export const SECURE_CODING = KA_CATEGORIES.secureCoding;

export const USED_ASSESSMENT_NAME_ERROR = "This assessment name is already taken";

export const notificationOptions = ["None", "Weekly", "Monthly", "Quarterly"] as const;
export type NotificationOption = (typeof notificationOptions)[number];

export const reminderTextMap: Record<NotificationOption, string> = {
  None: "No reminder emails will be sent.",
  Weekly: "Learners will receive reminder emails every week until the assessment is complete.",
  Monthly: "Learners will receive reminder emails every month until the assessment is complete.",
  Quarterly:
    "Learners will receive reminder emails every quarter until the assessment is complete.",
};

export const CATEGORY_VARIANTS = ["mauve", "blue", "teal", "indigo"] as const;

export const KA_CARD_IMAGE_MAP: Record<string, string> = {
  [KA_CATEGORIES.secureCoding]: SecureCodingImageUrl,
  [KA_CATEGORIES.coreSecurityConcepts]: SecureConceptsImageUrl,
  [KA_CATEGORIES.secureDevelopment]: SecureDevelopmentImageUrl,
  [KA_CATEGORIES.aiLlm]: AiLlmImageUrl,
  [KA_CATEGORIES.aiFoundations]: AiFoundationsImageUrl,
  [KA_CATEGORIES.aiSkillsAndWorkflows]: AiSkillsWorkflowsImageUrl,
  [KA_CATEGORIES.aiAgents]: AiAgentsImageUrl,
};

// The initial SVGs bake fade into the file, the newer SVGs don't so we apply those inline
export const FADED_KA_CARD_IMAGES = new Set<string>([
  KA_CATEGORIES.aiFoundations,
  KA_CATEGORIES.aiSkillsAndWorkflows,
  KA_CATEGORIES.aiAgents,
]);
